import { cn } from '$components'
import { SidebarLeftIcon } from '$components'
import { Button, Tooltip } from '$components'
import { useSidebar } from './hooks/use-sidebar'

export function SidebarResizeButton() {
  const { isOpen, toggleOpen } = useSidebar()

  return (
    <div className={cn(
      'flex items-center w-full px-stack-tight py-stack-tight justify-center',
      {
        'justify-end': isOpen,
      },
    )}
    >
      <Tooltip content={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}>
        <Button
          variant="secondary"
          size="sm"
          aria-label={`${isOpen ? 'Collapse' : 'Expand'} sidebar`}
          onClick={toggleOpen}
          className="!p-stack-tight hover:text-fg-inverse rounded-surface"
        >
          <SidebarLeftIcon className="size-4 transition-transform" />
        </Button>
      </Tooltip>
    </div>
  )
}
